import React, { useContext, useState } from "react";
import {
  Button, CircularProgress, ThemeProvider, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, IconButton, MenuItem,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, useMediaQuery, useTheme, Box, Select, FormControl, Paper, TableContainer,
  Popover, Typography, TextField
} from "@mui/material";
import CommonPagination from "../../common/common-pagination";
import { getConfig } from "../../common/env-config";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PropTypes from "prop-types";
import { creatorsTableTheme } from "../../../mui/mui-theme-component";
import CustomAlert from "../../common/alert";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { WindowWidthContext } from "../../context/user-details-context";
import Checkbox from '@mui/material/Checkbox';
import ApplicantsStatusTableToolbar from "./accepted-applicants-table-toolbar";
import PricePopover from "./PricePopover";
import dayjs from "dayjs";
import VideoOnDatePickerPopover from "../accepted applications/VideoOnDatePickerPopover";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LiveOnDatePickerPopover from "./LiveOnDatePickerPopover";
import Note_Edit from "../../../assets/Note_Edit.svg"
import ApplicantProfilePopup from "./applicant-profile-popup";
import { removeAcceptedCreator } from "../live-campaign-repository";
import AddPostLinkPopover from "./AddPostLinkPopover";

export default function AcceptedApplicantsList({ selectedApplicants, setSelectedApplicants,
  rowsPerPage, setRowsPerPage, fromPage, totalPages, loading, totalResults,
  apiFailed, creators, currentPage, setCurrentPage, noOfCreators, setFollowersFilterValue,
  campaignId, setRateAdded, campaignClosed, setCreatorAdded
}) {
  const windowWidth = useContext(WindowWidthContext);
  const { baseUrl } = getConfig();
  const [creatorId, setCreatorId] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [openApplicationAlert, setOpenApplicationAlert] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [followersFrom, setFollowersFrom] = useState('');
  const [followersTo, setFollowersTo] = useState('');
  const [followersFilterApply, setFollowersFilterApply] = useState(false);
  const [formatedSelectedApplicants, setFormatedSelectedApplicants] = useState([]);
  const [priceAnchorEl, setPriceAnchorEl] = useState(null);
  const [postLinkAnchorEl, setPostLinkAnchorEl] = useState(null);
  const [videoOnAnchorEl, setVideoOnAnchorEl] = useState(null);
  const [liveDateAnchorEl, setLiveDateAnchorEl] = useState(null);
  const [paymentRequest, setPaymentRequest] = useState(
    { creatorId: "", price: "", videoOnDate: "", liveDate: "" }
  );
  const [postLink, setPostLink] = useState();
  const [error, setError] = useState("");

  const handlePriceOpen = (event, creator) => {
    setPriceAnchorEl(event.currentTarget);
    handleCreatorRate(creator);
  };

  const handlePriceClose = () => {
    setPriceAnchorEl(null);
  };

  const handleOpenVideoOnPopover = (event, creator) => {
    setVideoOnAnchorEl(event.currentTarget);
    handleCreatorRate(creator);
  };

  const handleOpenLiveDatePopover = (event, creator) => {
    setLiveDateAnchorEl(event.currentTarget);
    handleCreatorRate(creator);
  };

  const handlePostLinkOpen = (event, creator) => {
    setPostLinkAnchorEl(event.currentTarget);
    setPostLink(creator.postLink);
    setCreatorId(creator.creatorId);
    setError("");
  };

  const handlePostLinkClose = () => {
    setPostLinkAnchorEl(null);
  };

  const handleCreatorRate = (creator) => {
    const updatedRequest = {
      ...paymentRequest,
      creatorId: creator.creatorId,
      price: creator.price,
    };

    if (creator.videoOnDate !== null && creator.videoOnDate !== "") {
      updatedRequest.videoOnDate = dayjs(creator.videoOnDate).format('YYYY-MM-DD');
    }

    if (creator.liveDate !== null && creator.liveDate !== "") {
      updatedRequest.liveDate = dayjs(creator.liveDate).format('YYYY-MM-DD');
    }

    setPaymentRequest(updatedRequest);
  };

  const handleCreatorRateSave = (fieldName, value) => {
    setPaymentRequest({
      ...paymentRequest,
      [fieldName]: value
    })
  }

  const handleRowSelect = (event, creator) => {
    const selectedIndex = selectedApplicants.findIndex(row => row.userId === creator.userId);
    let newSelected = [];
    let newFormatedSelectedApplicant = [...formatedSelectedApplicants];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(
        selectedApplicants,
        { userId: creator.userId, applicationStatus: creator.applicationStatus }
      );

      if (!creator.notificationSent) {
        newFormatedSelectedApplicant = newFormatedSelectedApplicant.concat(
          { userId: creator.userId, applicationStatus: creator.applicationStatus }
        );
      }
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedApplicants.slice(1));

      if (!creator.notificationSent) {
        newFormatedSelectedApplicant = newFormatedSelectedApplicant.filter(
          (row) => row.userId !== creator.userId
        );
      }
    } else if (selectedIndex === selectedApplicants.length - 1) {
      newSelected = newSelected.concat(selectedApplicants.slice(0, -1));

      if (!creator.notificationSent) {
        newFormatedSelectedApplicant = newFormatedSelectedApplicant.filter(
          (row) => row.userId !== creator.userId
        );
      }
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedApplicants.slice(0, selectedIndex),
        selectedApplicants.slice(selectedIndex + 1),
      );

      if (!creator.notificationSent) {
        newFormatedSelectedApplicant = newFormatedSelectedApplicant.filter(
          (row) => row.userId !== creator.userId
        );
      }
    }

    setSelectedApplicants(newSelected);
    setFormatedSelectedApplicants(newFormatedSelectedApplicant);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = creators.map((creator) => ({
        userId: creator.creatorId,
        applicationStatus: creator.applicationStatus,
      }));
      const formatedSelectedApplicants = creators
        .filter((creator) => !creator.notificationSent)
        .map((creator) => ({
          userId: creator.creatorId,
          applicationStatus: creator.applicationStatus,
        }));
      setSelectedApplicants(newSelecteds);
      setFormatedSelectedApplicants(formatedSelectedApplicants);
    } else {
      setSelectedApplicants([]);
      setFormatedSelectedApplicants([]);
    }
  };

  const handleApplicationAlertClose = () => {
    setOpenApplicationAlert(false);
  };

  const handleProfileOpen = (cId) => {
    setCreatorId(cId);
    setOpenProfile(true);
  };

  const handleProfileClose = () => {
    setOpenProfile(false);
  };

  const showAlert = (severity, message) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K";
    } else {
      const roundedNumber = Math.round(num * 100) / 100;
      if (Number.isInteger(roundedNumber)) {
        return roundedNumber.toString();
      } else {
        return roundedNumber.toFixed(2);
      }
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    if (setSelectedApplicants) {
      setSelectedApplicants([]);
    }
  };

  const handleRemoveApplication = async (creatorPhoneNumber) => {
    try {
      console.log(creatorPhoneNumber);
      await removeAcceptedCreator(campaignId, creatorPhoneNumber, setCreatorAdded);
      showAlert("success", `Application Rejected successfully.`);
    } catch (error) {
      showAlert("error", `Failed to Rejected application. Please try again.`);
    }
  };

  const creatorColumns = [
    {
      id: 1,
      label: `Showing ${apiFailed || loading ? 0 : ((currentPage - 1) * rowsPerPage) + 1} - ${apiFailed || loading ? 0 : Math.min(currentPage * rowsPerPage, totalResults)} of ${apiFailed || loading ? 0 : totalResults} ${"applicants"
        }`,
      minWidth: 260,
    },
    { id: 2, label: "Followers", minWidth: 120, filter: true },
    { id: 3, label: "Price", minWidth: 140 },
    { id: 4, label: "Video submit", minWidth: 140 },
    { id: 5, label: "Live date", minWidth: 140 },
    { id: 6, label: "Add Link", minWidth: 150 },
    { id: 7, label: "Action", minWidth: 100 },
    { id: 8, label: "Type", minWidth: 100 }
  ];

  const handleRowPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  }

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleFollowersFilterChange = () => {
    const min = parseInt(followersFrom, 10);
    const max = parseInt(followersTo, 10);
    setFollowersFilterValue({ min, max });
    setAnchorEl(null);
    setFollowersFilterApply(true);
    setSelectedApplicants([]);
    setCurrentPage(1);
  };

  const handleClearFilter = () => {
    setFollowersFilterValue({ min: '', max: '' });
    setFollowersFrom('');
    setFollowersTo('');
    setFollowersFilterApply(false);
    setCurrentPage(1);
  };

  const openFollowersFilter = Boolean(anchorEl);
  const id = openFollowersFilter ? 'simple-popover' : undefined;

  const handleFollowersFromInputChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      setFollowersFrom(value);
    }
  };

  const handleFollowersToInputChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      setFollowersTo(value);
    }
  };

  return (
    <>
      <ThemeProvider theme={creatorsTableTheme}>
        <Box sx={{ width: windowWidth <= 799 ? '100vw' : '100%' }}>
          <Paper sx={{ width: windowWidth <= 799 ? '100vw' : '100%', mb: 2, backgroundColor: !fromPage ? '#fff' : '#f4f5f8', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <TableContainer sx={{ overflowX: 'auto', flexGrow: 1, scrollbarWidth: 'none', '-ms-overflow-style': 'none' }}>
              {selectedApplicants && selectedApplicants.length > 0 && (
                <ApplicantsStatusTableToolbar selectedApplicants={selectedApplicants} campaignId={campaignId} formatedSelectedApplicants={formatedSelectedApplicants} />
              )}
              <Table aria-labelledby="tableTitle" className={`influencers-inner-container ${fromPage ? "creators-list-container" : ""
                }`}>
                <TableHead>
                  {fromPage ? (
                    <>
                      <TableRow sx={{ height: "3em" }}></TableRow>
                      <TableRow sx={{ height: "3em" }}>
                        <label className="creators-list-label">Creators List</label>
                      </TableRow>
                    </>
                  ) : null}
                  <TableRow>
                    {campaignClosed && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="secondary"
                          indeterminate={selectedApplicants.length > 0 && selectedApplicants.length < creators.length}
                          checked={creators.length > 0 && selectedApplicants.length === creators.length}
                          onChange={handleSelectAllClick}
                          inputProps={{ 'aria-label': 'select all creators' }}
                        />
                      </TableCell>
                    )}
                    {creatorColumns.map((column) => (
                      <TableCell
                        sx={{
                          backgroundColor: "transparent",
                          fontWeight: 600,
                          color: "#9a9898",
                        }}
                        key={column.id}
                        style={{
                          minWidth: column.minWidth,
                        }}
                      >
                        <div className="top-campaign-tooltip">
                          {column.label}
                          {column.filter && column.id === 2 && (
                            <>
                              <Tooltip title="Filter by followers">
                                <IconButton onClick={followersFilterApply ? handleClearFilter : handleFilterClick}>
                                  {followersFilterApply ? <FilterAltOffIcon /> : <FilterAltIcon aria-describedby={id} />}
                                </IconButton>
                              </Tooltip>
                              <Popover id={id} open={openFollowersFilter}
                                anchorEl={anchorEl} onClose={handleFilterClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                              >
                                <Typography sx={{ p: 3 }}>
                                  <div className='date-range-div'>
                                    <div className='date-range-col'>
                                      <div className='date-range-text'>Followers From:</div>
                                      <TextField value={followersFrom} placeholder='Followers From' variant="outlined" type='number'
                                        inputProps={{ min: "0", max: "1000000000", pattern: "[0-9]*" }}
                                        onChange={handleFollowersFromInputChange}
                                      />
                                    </div>
                                    <div className='date-range-col'>
                                      <div className='date-range-text'>Followers To:</div>
                                      <TextField value={followersTo} placeholder="Followers To" variant="outlined" type='number'
                                        inputProps={{ min: "0", max: "1000000000", pattern: "[0-9]*" }}
                                        onChange={handleFollowersToInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className='date-range-footer'>
                                    <Button disabled={followersFrom === '' || followersTo === ''} onClick={handleFollowersFilterChange}>
                                      Apply Filter
                                    </Button>
                                  </div>
                                </Typography>
                              </Popover>
                            </>
                          )}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={creatorColumns.length} align="center">
                        <div style={{ height: "20vh" }}>
                          <CircularProgress />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <>
                      {" "}
                      {apiFailed ? (
                        <TableRow>
                          <TableCell colSpan={creatorColumns.length} align="center">
                            <div className="nodata-found">
                              No Application found
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : (
                        <>
                          {creators.map((creator, index) => {
                            const isItemSelected = selectedApplicants && selectedApplicants.some(row => row.userId === creator.creatorId);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow key={creator.creatorId} selected={isItemSelected} className="top-campaign-row">
                                {campaignClosed && (
                                  <TableCell sx={{ padding: "0.3rem" }}>
                                    <Checkbox color="secondary"
                                      checked={isItemSelected}
                                      onChange={(event) => handleRowSelect(event, creator)}
                                      inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                  </TableCell>
                                )}
                                <TableCell
                                  sx={{
                                    maxWidth: "-webkit-fill-available",
                                  }}
                                  className="top-creator-name"
                                >
                                  <div
                                    className="influencers-profile-outer-container"
                                    onClick={() =>
                                      handleProfileOpen(creator.creatorId)
                                    }
                                  >
                                    <div
                                      className="influencers-profile-container avatar-box"
                                      style={{
                                        backgroundImage: `url(${creator.profilePictureId ? (
                                          `${baseUrl}/download-insta-profile/${creator.profilePictureId}`
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 23 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="_verified_dbbth_91"
                                          >
                                            <path
                                              d="M22.5 11L20.06 8.21L20.4 4.52L16.79 3.7L14.9 0.5L11.5 1.96L8.1 0.5L6.21 3.69L2.6 4.5L2.94 8.2L0.5 11L2.94 13.79L2.6 17.49L6.21 18.31L8.1 21.5L11.5 20.03L14.9 21.49L16.79 18.3L20.4 17.48L20.06 13.79L22.5 11ZM8.88 15.01L6.5 12.61C6.11 12.22 6.11 11.59 6.5 11.2L6.57 11.13C6.96 10.74 7.6 10.74 7.99 11.13L9.6 12.75L14.75 7.59C15.14 7.2 15.78 7.2 16.17 7.59L16.24 7.66C16.63 8.05 16.63 8.68 16.24 9.07L10.32 15.01C9.91 15.4 9.28 15.4 8.88 15.01Z"
                                              fill="#4AABED"
                                            ></path>
                                          </svg>
                                        )
                                          })`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="influencer-data-block">
                                    <div
                                      className="influencer-name-block"
                                      onClick={() =>
                                        handleProfileOpen(creator.creatorId)
                                      }
                                    >
                                      <div className="influencer-name">
                                        {creator.creatorFullName}
                                      </div>
                                    </div>
                                    <a
                                      className="influencer-handle-block influencer-handle"
                                      href={`https://www.instagram.com/${creator.instaHandle}`}
                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <span>@{creator.instaHandle}</span>
                                    </a>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    maxWidth: 130,
                                    overflowWrap: "break-word",
                                  }}
                                  onClick={() => handleProfileOpen(creator.creatorId)}
                                >
                                  <div className="followers-outer-box followers-data-block">
                                    <div
                                      className={`followers-count ${fromPage ? "followers-count-highlight" : ""
                                        }`}
                                    >
                                      {formatNumber(creator.followersCount)}
                                    </div>
                                    <div className="followers-label">Followers</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    maxWidth: 100,
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <div className="followers-outer-box followers-data-block">
                                    {creator.price ? (
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="followers-count">₹ {creator.price}</span>
                                        <Button
                                          color="secondary"
                                          onClick={(e) => handlePriceOpen(e, creator)}
                                        >
                                          <img src={Note_Edit} alt="note edit" style={{ width: '50%' }}></img>
                                        </Button>
                                      </div>
                                    )
                                      : (
                                        <Button variant="outlined" color="secondary" size="sm" sx={{
                                          textTransform: "capitalize",
                                          "&:hover": {
                                            backgroundColor: "#6B21A8",
                                            color: "#fff",
                                          },
                                        }}
                                          onClick={(e) => handlePriceOpen(e, creator)}>
                                          Add Price
                                        </Button>
                                      )}
                                    <PricePopover
                                      anchorEl={priceAnchorEl}
                                      handleClose={handlePriceClose}
                                      campaignId={campaignId}
                                      paymentRequest={paymentRequest}
                                      handleCreatorRateSave={handleCreatorRateSave}
                                      setRateAdded={setRateAdded}
                                      setPaymentRequest={setPaymentRequest}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    maxWidth: 150,
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <div className="followers-outer-box followers-data-block">
                                    <Box display="flex" alignItems="center" gap={2}>
                                      {creator.videoOnDate ? (
                                        <Box display="flex" alignItems="center" gap={1}>
                                          <Typography className="followers-count" variant="body1" sx={{ fontWeight: 500 }}>
                                            {dayjs(creator.videoOnDate).format("DD MMM, YYYY")}
                                          </Typography>
                                          <CalendarMonthIcon sx={{ color: "#9333EA" }} onClick={(e) => handleOpenVideoOnPopover(e, creator)} />
                                        </Box>
                                      )
                                        : (
                                          <Button
                                            variant="outlined"
                                            color="secondary"
                                            size="sm"
                                            onClick={(e) => handleOpenVideoOnPopover(e, creator)}
                                            sx={{
                                              textTransform: "capitalize",
                                              "&:hover": {
                                                backgroundColor: "#6B21A8",
                                                color: "#fff",
                                              },
                                            }}
                                          >
                                            Select Date
                                          </Button>
                                        )}
                                      <VideoOnDatePickerPopover
                                        anchorEl={videoOnAnchorEl}
                                        setVideoOnAnchorEl={setVideoOnAnchorEl}
                                        handleCreatorRateSave={handleCreatorRateSave}
                                        campaignId={campaignId}
                                        paymentRequest={paymentRequest}
                                        setRateAdded={setRateAdded}
                                        setPaymentRequest={setPaymentRequest}
                                      />
                                    </Box>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    maxWidth: 150,
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <div className="followers-outer-box followers-data-block">
                                    <Box display="flex" alignItems="center" gap={2}>
                                      {creator.liveDate ? (
                                        <Box display="flex" alignItems="center" gap={1}>
                                          <Typography className="followers-count" variant="body1" sx={{ fontWeight: 500 }}>
                                            {dayjs(creator.liveDate).format("DD MMM, YYYY")}
                                          </Typography>
                                          <CalendarMonthIcon sx={{ color: "#9333EA" }} onClick={(e) => handleOpenLiveDatePopover(e, creator)} />
                                        </Box>
                                      )
                                        : (
                                          <Button
                                            variant="outlined"
                                            color="secondary"
                                            size="sm"
                                            onClick={(e) => handleOpenLiveDatePopover(e, creator)}
                                            sx={{
                                              textTransform: "capitalize",
                                              "&:hover": {
                                                backgroundColor: "#6B21A8",
                                                color: "#fff",
                                              },
                                            }}
                                          >
                                            Select Date
                                          </Button>
                                        )}

                                      <LiveOnDatePickerPopover
                                        anchorEl={liveDateAnchorEl}
                                        setLiveDateAnchorEl={setLiveDateAnchorEl}
                                        handleCreatorRateSave={handleCreatorRateSave}
                                        campaignId={campaignId}
                                        paymentRequest={paymentRequest}
                                        setRateAdded={setRateAdded}
                                        setPaymentRequest={setPaymentRequest}
                                      />
                                    </Box>
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    maxWidth: 100,
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <div className="followers-outer-box followers-data-block">
                                    {creator.postLink ? (
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="followers-count">{creator.postLink}</span>
                                        <Button
                                          color="secondary"
                                          onClick={(e) => handlePostLinkOpen(e, creator)}
                                        >
                                          <img src={Note_Edit} alt="note edit" style={{ width: '50%' }}></img>
                                        </Button>
                                      </div>
                                    )
                                      : (
                                        <Button variant="outlined" color="secondary" size="sm" sx={{
                                          textTransform: "capitalize",
                                          "&:hover": {
                                            backgroundColor: "#6B21A8",
                                            color: "#fff",
                                          },
                                        }}
                                          onClick={(e) => handlePostLinkOpen(e, creator)}>
                                          Add Link
                                        </Button>
                                      )}
                                    <AddPostLinkPopover
                                      anchorEl={postLinkAnchorEl}
                                      handleClose={handlePostLinkClose}
                                      campaignId={campaignId}
                                      creatorId={creatorId}
                                      postLink={postLink}
                                      setPostLink={setPostLink}
                                      setRateAdded={setRateAdded}
                                      error={error}
                                      setError={setError}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    minWidth: 100,
                                    padding: "0.7rem",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <div className="application-action-button">
                                    {creator.applicationStatus === "Accepted" && (
                                      <>
                                        <IconButton sx={{ color: "#4caf50", pointerEvents: "none" }}>
                                          <CheckCircleIcon />
                                        </IconButton>
                                        <IconButton
                                          sx={{ '&:hover': { color: "#f44336" } }}
                                          onClick={(e) =>
                                            handleRemoveApplication(creator.creatorId)
                                          }
                                        >
                                          <Tooltip title="Reject" placement="top">
                                            <HighlightOffIcon />
                                          </Tooltip>
                                        </IconButton>
                                      </>
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "0.7rem",
                                    overflowWrap: "break-word"
                                  }}
                                >
                                  {creator.type}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </>
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </ThemeProvider>
      {!loading ? (
        <div className={windowWidth <= 799 ? "pagination-container-mobile pagination-container" : "pagination-container"}>
          <Box sx={{ width: 'fit-content', display: 'flex', alignItems: 'center', columnGap: '13px' }}>
            <div>Records Per page :</div>
            <FormControl>
              <Select sx={{ backgroundColor: '#fff', width: 'fit-content' }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={rowsPerPage}
                onChange={(e) => handleRowPerPageChange(e.target.value)}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <CommonPagination currentPage={currentPage} totalPages={totalPages}
            handlePageChange={handlePageChange} />
          {openProfile && (
            <ApplicantProfilePopup
              creatorId={creatorId}
              campaignId={campaignId}
              openProfile={openProfile}
              onClose={handleProfileClose}
            />
          )}
        </div>
      ) : null}
      <Dialog
        fullScreen={fullScreen}
        open={openApplicationAlert}
        onClose={handleApplicationAlertClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Warning"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Creators Required: {noOfCreators}. You have already accepted {noOfCreators} applications, To accept a new application, please reject an existing one first.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleApplicationAlertClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <CustomAlert
        open={alertOpen}
        severity={alertSeverity}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
}

AcceptedApplicantsList.propTypes = {
  fromPage: PropTypes.any,
};
